import { useTranslate } from '@/translations';
import { FprDetailData } from '@/types';
import { Descriptions } from 'antd';
import React, { FC } from 'react';

interface FprResponsesProps {
  detail: FprDetailData;
}

export const FprDetail: FC<FprResponsesProps> = ({ detail }) => {
  const { t } = useTranslate();
  return (
    <Descriptions
      column={1}
      size="small"
      bordered
      items={[
        {
          key: '1',
          label: t('engineType'),
          children: detail.engineType,
        },
        {
          key: '2',
          label: t('Battery12V'),
          children: detail.battery12V ? 'Yes' : 'No',
        },
        {
          key: '3',
          label: t('HVBattery'),
          children: detail.batteryHv ? 'Yes' : 'No',
        },
        {
          key: '4',
          label: t('howManyKeys'),
          children: detail.numberOfKeys,
        },
      ]}
    />
  );
};
